import { useState } from "react"
import { useDraggable } from "@dnd-kit/core"
import { Popover } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faClipboard } from "@fortawesome/pro-regular-svg-icons"
import dayjs from "dayjs"
import { ConsultationCalendarEvent } from "../scheduleApi"
import ConsultationPopoverContent from "../ConsultationPopoverContent"
import { HOVER_POPOVER_OVERLAY_STYLE } from "../scheduleEventStyles"
import { getMonthCardStyles } from "./monthCardStyles"

export type Props = {
  consultation: ConsultationCalendarEvent
  onConsultationClick?: (consultation: ConsultationCalendarEvent) => void
}

const MonthViewConsultation = ({ consultation, onConsultationClick }: Props) => {
  const { attributes, listeners, setNodeRef, isDragging, transform } = useDraggable({
    id: `consultation-${consultation.id}`,
    data: { consultation, isConsultation: true },
  })

  const [isHovering, setIsHovering] = useState(false)

  const startTime = dayjs(consultation.start)

  const formatTime = () => {
    if (consultation.allDay) {
      return 'All Day'
    }
    return startTime.format('h:mmA')
  }

  const borderColor = consultation.organizerColor || '#e0e0e0'

  const { outerStyle, innerStyle } = getMonthCardStyles({ color: borderColor, isDragging, transform })

  return (
    <Popover
      content={<ConsultationPopoverContent consultation={consultation} />}
      open={isHovering && !isDragging}
      placement="right"
      overlayStyle={HOVER_POPOVER_OVERLAY_STYLE}
    >
      <div
        ref={setNodeRef}
        {...listeners}
        {...attributes}
        onClick={(e) => {
          e.stopPropagation()
          if (onConsultationClick) {
            onConsultationClick(consultation)
          }
        }}
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        style={outerStyle}
      >
        <div style={innerStyle}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4, color: '#999', fontSize: 11 }}>
            <FontAwesomeIcon icon={faClipboard} style={{ fontSize: 11 }} />
            <span>CONSULTATION</span>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <span style={{ fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1, minWidth: 0 }}>
              {consultation.customer.displayName}
            </span>
          </div>
          <span style={{ color: '#666', fontSize: 12, whiteSpace: 'nowrap' }}>{formatTime()}</span>
        </div>
      </div>
    </Popover>
  )
}

export default MonthViewConsultation
